// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Text, Box, Title } from '@nerdwallet/currency';
import Step from './step';
import Row from '../row/row';

import parseMdLinks from '../../lib/parse-md-links';

import './three-steps.less';

const titleSizeEnum = {
  1: 'x-small',
  2: 'small',
  3: 'default',
};

const ThreeSteps = ({
  anchorId,
  backgroundColor,
  steps,
  className,
  title,
  subtitle,
  titleLevel,
  button,
}) => {
  const ctaButton = button && (
    <Box
      className={classNames(['three-steps__button', classes('padding-top-3')])}
    >
      {button}
    </Box>
  );

  return (
    <Row
      className={classNames([
        'three-steps',
        classes('padding-vertical-5'),
        className,
      ])}
      backgroundColor={backgroundColor}
      id={anchorId}
    >
      {title && (
        <Title
          className="three-steps__title centered-in-parent"
          size={titleSizeEnum[titleLevel]}
        >
          {title}
        </Title>
      )}
      {subtitle && (
        <Box
          className={classNames([
            'three-steps__subtitle',
            'centered-in-parent',
          ])}
        >
          <Text component="p" size="small">
            {parseMdLinks(subtitle)}
          </Text>
        </Box>
      )}
      <Box
        className={classNames([
          'three-steps__steps nw-row',
          {
            [classes('padding-top-2')]: title,
          },
        ])}
      >
        {steps.map((step) => (
          <Step key={step.name} {...step} />
        ))}
      </Box>
      {ctaButton}
    </Row>
  );
};

ThreeSteps.propTypes = {
  anchorId: PropTypes.string,
  backgroundColor: PropTypes.string,
  steps: PropTypes.array,
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  titleLevel: PropTypes.string,
  button: PropTypes.element,
};

ThreeSteps.defaultProps = {
  steps: [],
  className: '',
  titleLevel: '2',
};

export default ThreeSteps;
